export default "__VITE_ASSET__DRPdnmri__"